import React from "react";
import { Chart as ChartJS } from "chart.js/auto";
import { Bar } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";
import moment from "moment";

const HorizontalBarchart = ({ chartsData }) => {
  const dates = chartsData?.map(
    (item) =>
      `${moment(item.date_from)
        .tz("Asia/Kolkata")
        .format("DD-MM-YYYY")} TO ${moment(item.date_to)
        .tz("Asia/Kolkata")
        .format("DD-MM-YYYY")}`
  );

  const monthNames = chartsData?.map((item, index) => `S ${index + 1}`);

  const data = {
    labels: monthNames,
    datasets: [
      {
        data: chartsData?.map((item) => item.total),
        backgroundColor: [
          "gray",
          "blue",
          "yellow",
          "green",
          "red",
          "orange",
          "pink",
          "purple",
          "brown",
          "cyan",
          "lime",
          "indigo",
        ],
        datalabels: {
          anchor: "end",
          align: "end",
          formatter: function (value, context) {
            return Number(value).toLocaleString();
          },
          font: {
            weight: "500",
          },
        },
      },
    ],
  };

  const options = {
    indexAxis: "y",
    barPercentage: 1,
    categoryPercentage: 0.8,
    elements: {
      bar: {
        borderWidth: 0,
        borderRadius: 10,
      },
    },
    scales: {
      x: {
        display: false,
      },
      y: {
        display: true,
        grid: {
          display: false,
        },
      },
    },
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: false,
      },
      layout: {
        padding: 50,
      },
      datalabels: {
        anchor: "end",
        align: "end",
        font: {
          weight: "500",
        },
        formatter: function (value, context) {
          return Number(value).toLocaleString();
        },
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            let label = context.dataset.label || "";
            if (label) {
              label += ": ";
            }
            const value = Number(context.formattedValue).toLocaleString();
            const date = dates[context.dataIndex];
            return label + value + " (" + date + ")";
          },
        },
      },
    },
  };

  return (
    <>
      {chartsData?.length > 0 ? (
        <Bar options={options} data={data} plugins={[ChartDataLabels]} />
      ) : (
        <span className="noDataFound">No Data Found!</span>
      )}
    </>
  );
};

export default HorizontalBarchart;
